import React, { useContext, lazy, Suspense, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DispatchContext from "../DispatchContext.js";

// Lazy loading pentru componentele din meniu
const Trending = lazy(() => import("./Trending.js"));
const MostRead = lazy(() => import("./MostRead.js"));
const ForYou = lazy(() => import("./ForYou.js"));
const Categories = lazy(() => import("./Categories.js"));

function Menu() {
    const dispatch = useContext(DispatchContext);
    const location = useLocation();

    useEffect(() => {
        console.log("[Menu] MOUNT");
        return () => console.log("[Menu] UNMOUNT");
    }, []);

    const handleMenuClick = () => {
        dispatch({ type: "stopTimer" });
    };

    const changeStation = (station) => {
        return () => {
            dispatch({ type: "setActiveStation", value: station });
            handleMenuClick();
        };
    };

    const handleTrayContent = (Component) => {
        return () => {
            dispatch({ 
                type: "setTrayContent", 
                value: () => (
                    <Suspense fallback={<div>Se încarcă...</div>}>
                        <Component />
                    </Suspense>
                )
            });
            handleMenuClick();
        };
    };

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('subscriptionId');
        localStorage.removeItem('subscriptionLevel');
        localStorage.removeItem('__paypal_storage__');
        dispatch({ type: "userLoggedOut" });
        dispatch({ type: "setTrayContent", value: null });
        dispatch({ type: "setTrayVisible", value: false });
    };

    // Detectăm dacă suntem pe mobil (portrait)
    const isMobile = typeof document !== 'undefined' && document.body.classList.contains('portrait');

    return (
        <div className="menu-container" onClick={handleMenuClick}>
            <div className="menu-logo">
                <img src="/assets/img/logo-aleph-rosu.png" alt="Logo Aleph" />
            </div>
            
            <div className="menu-sections">
                <div className="menu-column">
                    <div className="menu-section">
                        <h3>Live TV</h3>
                        <ul>
                            <li><a href="#!" onClick={changeStation(0)}>Aleph News</a></li>
                            <li><a href="#!" onClick={changeStation(1)}>Aleph Business</a></li>
                        </ul>
                    </div>
                    <div className="menu-section">
                        <h3>Cont</h3>
                        <ul>
                            <li><Link to="/account">Contul meu</Link></li>
                            <li><a href="#!" onClick={handleLogout}>Deautentificare</a></li>
                        </ul>
                    </div>
                </div>

                <div className="menu-column">
                    <div className="menu-section">
                        <ul>
                            <li><a href="https://alephnews.ro">Aleph News</a></li>
                            <li><a href="https://alephbusiness.ro">Aleph Business</a></li>
                            <li><a href="https://alephmentor.ro">Aleph Mentor</a></li>
                            <li><a href="https://alephcult.ro">Aleph Cult</a></li>
                            <li><a href="https://alephhealth.ro">Aleph Health</a></li>
                            <li><a href="https://stiu.alephnews.ro">Știu</a></li>
                            <li><a href="https://stiupecelumetraiesc.alephnews.ro">Știu pe ce lume trăiesc</a></li>
                        </ul>
                    </div>
                </div>

                <div className="menu-column">
                    <div className="menu-section">
                        <ul>
                            <li><a href="https://zf.ro">Ziarul Financiar</a></li>
                            <li><a href="https://zfcorporate.ro">ZF Corporate</a></li>
                            <li><a href="https://businessmagazin.ro">Business Magazin</a></li>
                        </ul>
                    </div>
                </div>

                <div className="menu-column">
                    <div className="menu-section">
                        <ul>
                            <li><Link to="#!" onClick={handleTrayContent(Trending)}>Trending</Link></li>
                            <li><Link to="#!" onClick={handleTrayContent(MostRead)}>Most Read</Link></li>
                            <li><Link to="#!" onClick={handleTrayContent(ForYou)}>For You</Link></li>
                            <li><Link to="#!" onClick={handleTrayContent(Categories)}>Categorii</Link></li>
                        </ul>
                    </div>
                </div>

                {/* Secțiune informativă DOAR pe mobil */}
                {isMobile && (
                  <div className="menu-column">
                    <div className="menu-section info-section">
                      <h3>Informații</h3>
                      <ul>
                        <li><Link to="/about">Despre noi</Link></li>
                        <li><Link to="/terms">Termeni și condiții</Link></li>
                        <li><Link to="/privacy">Politica de confidențialitate</Link></li>
                        <li><Link to="/dispute">Disputarea tranzacțiilor</Link></li>
                      </ul>
                    </div>
                  </div>
                )}
            </div>
            {/* Footer doar pe desktop (landscape) */}
            {!isMobile && (
              <footer className="footer">
                  <ul className="footer-links">
                      <li><Link to="/about">Despre noi</Link></li>
                      <li><Link to="/terms">Termeni și condiții</Link></li>
                      <li><Link to="/privacy">Politica de confidențialitate</Link></li>
                      <li><Link to="/dispute">Disputarea tranzacțiilor</Link></li>
                  </ul>
              </footer>
            )}
        </div>
    );
}

export default Menu;
